import React from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUser, FaEdit } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "./Contact.css";
import Footer from "./Footer";

const Contact = () => {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "0710c64b-9436-4dbb-9e52-6d4a5137a6af");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData, // Send FormData directly, no JSON.stringify
    });

    const data = await response.json();

    if (data.success) {
      setResult("");
      alert("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.error("Error:", data);
      alert(data.message || "Something went wrong.");
      setResult("");
    }
  };

  return (
    <>
      <div className="contact-container">
        <div className="contact-info">
          <div className="info-card">
            <FaEnvelope className="icon" />
            <h3>Email Address</h3>
            <p>akari.sa@outlook.com</p> {/* corrected the domain */}
          </div>
          <div className="info-card">
            <FaPhone className="icon" />
            <h3>Phone Number</h3>
            <p>+9660504920299 <br />+9660567757103 <br/>+9660535493047</p>
          </div>
          <div className="info-card">
            <FaMapMarkerAlt className="icon" />
            <h3>Office Address</h3>
            <p>Saudi Arabia, Al-Ahsa, Thirty, Building-number-8012, zip-code-36365</p>
          </div>
        </div>

        <div className="quote-form">
          <h2>We'd love to hear from you</h2>
          <form onSubmit={onSubmit}>
            <div className="input-group">
              <input type="text" name="name" placeholder="Enter your name" required />
              <FaUser className="input-icon" />
            </div>
            <div className="input-group">
              <input type="email" name="email" placeholder="Enter email address" required />
              <MdEmail className="input-icon" />
            </div>
            <div className="input-group">
              <input type="tel" name="phone" placeholder="Enter phone number" required />
              <FaPhone className="input-icon" />
            </div>
            <div className="input-group textarea">
              <textarea name="message" placeholder="Enter message" required></textarea>
              <FaEdit className="input-icon" />
            </div>
            <button type="submit" className="btn">{result || "Send Message"}</button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;















